<template>
  <b-modal
    v-model="show"
    hide-header
    hide-footer
    centered
    @hide="hideModal"
  >
    <form
      id="editModal"
      @submit.prevent="editTemplate"
    >
      <div class="modal-header align-items-center">
        <h2
          id="ModalLabel"
          class="modal-title"
        >
          Редактирование шаблона
        </h2>
        <i class="material-icons">edit</i>
      </div>
      <div class="modal-body">
        <div
          class="d-flex justify-content-between"
        >
          <div class="d-inline-block">
            Имя шаблона:
            <span id="login_place">
              {{ templateEdited.name }}
            </span>
          </div>
          <div
            class="d-inline-flex custom-control custom-switch"
          >
            <input
              v-if="eventState.name"
              id="isEventActive"
              v-model="eventState.sendMail"
              class="custom-control-input"
              type="checkbox"
              @change="submitEventState"
            >
            <label
              class="custom-control-label"
              for="isEventActive"
              @click="submitEventState"
            >Email event: {{ eventStateText }}</label>
          </div>
        </div>
        <hr>
        <div
          v-for="it in fields"
          :key="it.key"
          class="form-group"
        >
          <label
            :for="it.key"
            class="col-form-label"
          >
            {{ it.label }}
          </label>
          <input
            :id="it.key"
            v-model="templateEdited[it.key]"
            class="form-control"
            :placeholder="it.label"
          >
        </div>
        <b-form-group class="create-orders-by-file__file mt-4">
          <input
            id="order-file"
            ref="file"
            type="file"
            accept=".json"
            class="d-none"
            @change="setFile"
          />
          <button
            id="order-file"
            type="button"
            class="btn btn-primary-ford-orange white"
            @click.prevent="selectFile"
          >
            <label
              class="full-size"
              for="order-file"
            ></label>
            <i class="material-icons">file_upload</i>
            Загрузить файл
          </button>
          <span class="create-orders-by-file__file-name">
            {{ file ? file.name : `Файл не выбран` }}
          </span>
        </b-form-group>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-secondary-ford-gray modal-ext"
          type="button"
          @click="hideModal"
        >
          Отмена
        </button>
        <button
          class="btn btn-primary-ford-orange modal-ext"
          type="submit"
        >
          Изменить
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  name: 'EditTemplate',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    templateEdited: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    show: false,
    fields: [
      {
        key: 'subject',
        label: 'Тема',
      },
      {
        key: 'to',
        label: 'Кому',
      },
      {
        key: 'cc',
        label: 'В копии',
      },
      {
        key: 'from',
        label: 'От',
      },
    ],
    fileEjs: null,
    fileAttachments: null,
    file: null,
    eventState: {},
  }),
  computed: {
    eventStateText() {
      if (!this.eventState || !this.eventState.name) { return 'Not found'; }

      return this.eventState.sendMail ? 'Enabled' : 'Disabled';
    },
  },
  watch: {
    value(val) {
      this.show = val;
      if (val) {
        this.getEventList();
      }
    },
  },
  mounted() {
    this.getEventList();
  },
  methods: {
    async getEventList() {
      const { items } = await this.$http.get('mailer/1.0/events');
      const event = items.find(it => it.name === this.templateEdited.name);

      if (event) {
        this.eventState = event;
      } else {
        this.eventState = {};
      }
    },
    async submitEventState() {
      const data = {
        name: this.templateEdited.name,
        saveDb: true,
        sendMail: false,
        ...this.eventState,
      };

      await this.$http.post('mailer/1.0/event', data);

      if (!this.eventState.name) {
        this.getEventList();
      }
    },
    hideModal() {
      Object.assign(this.$data, this.$options.data());
      this.$emit('input', false);
    },
    async editTemplate() {
      const requestOptions = {
        subject: this.templateEdited.subject,
        to: this.templateEdited.to,
        cc: this.templateEdited.cc,
        from: this.templateEdited.from,
        ejs: this.fileEjs || this.templateEdited.ejs,
        attachments: this.fileAttachments || this.templateEdited.attachments,
      };

      await this.$http.patch(`mailer/1.0/template/${this.templateEdited.name}`, requestOptions);

      Object.assign(this.$data, this.$options.data());
      this.$emit('editTemplate');
    },
    selectFile() {
      this.$refs.file.value = '';
      this.$refs.file.click();
    },
    async setFile() {
      const file = this.$refs.file.files[0];
      this.file = file;
      if (file) {
        const { ejs, attachments } = await this.parseJsonFile(file);
        this.fileEjs = ejs;
        this.fileAttachments = attachments;
        return;
      }
      this.fileEjs = null;
      this.fileAttachments = null;
    },
    parseJsonFile(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = event => resolve(JSON.parse(event.target.result));
        fileReader.onerror = error => reject(error);
        fileReader.readAsText(file);
      });
    },
  },
};
</script>
